import { Exclude, Expose, Type } from 'class-transformer';
import { Point } from 'geojson';

import { Default, ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { FususRegionCode } from '../constants';
import { SnFloor, SnLocation } from '../location';
import { FsCameraPlacement } from './camera-placement';

export class FsPanorama extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public image: any;

  @Expose()
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public dateTaken: Date;

  @Expose({ name: 'createdTimestamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public createdAt: Date;

  @Expose({ name: 'updatedTimestamp' })
  @Type(() => Date)
  @Exclude({ toPlainOnly: true })
  public updatedAt: Date;

  @Expose()
  public location: SnLocation;

  @Expose()
  public floor: SnFloor;

  @Expose()
  public region?: FususRegionCode;

  @Expose()
  public disposition: any;

  @Expose()
  public geometry: Point;

  @Expose()
  @Default(90)
  public heading: number;

  @Expose()
  @Default(0.1)
  public cameraRange: number;

  @ExposeRawData()
  public cameraPlacements: FsCameraPlacement;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
